export default __webpack_public_path__ + "static/media/app4.7db6e800.png";